import { render, staticRenderFns } from "./raiseDepositTicketGateway.vue?vue&type=template&id=4a7640e8&lang=pug"
import script from "./raiseDepositTicketGateway.vue?vue&type=script&lang=js"
export * from "./raiseDepositTicketGateway.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports